import { useGlobalState } from "./stateProvider/StateProvider";

export const Subscriptions = {
    Silver: 'Silver',
    Gold: 'Gold',
}

//state safe no-hooks version for use when needed in loops/map or similar
export const SiteHasSubscription = (siteSubscriptions, requiredSubscriptions) => {
    return evaluateSubscriptionRequirement(siteSubscriptions, requiredSubscriptions);
}

//bool check if subscription is active or not
export const HasSubscription = (requiredSubscriptions) => {
    const { state: { subscriptions } } = useGlobalState();
    return evaluateSubscriptionRequirement(subscriptions, requiredSubscriptions);
}

// wrapper that conditionally renders children based on active subscriptions
// <RequireSubscription requiredSubscriptions={Subscriptions.Gold}></RequireSubscription> ==> requires Gold
// <RequireSubscription requiredSubscriptions={[Subscriptions.Silver, Subscriptions.Gold]}></RequireSubscription> ==> requires either Silver or Gold
// <RequireSubscription requiredSubscriptions={{all: [Subscriptions.Silver], any: [Subscriptions.Gold]}}></RequireSubscription> ==> requires Silver AND either Gold
const RequireSubscription = ({ requiredSubscriptions, children }) => {
    const { state: { subscriptions } } = useGlobalState();
    return evaluateSubscriptionRequirement(subscriptions, requiredSubscriptions)
        ? children
        : null;
}

export default RequireSubscription;

// Supports: string or array (OR logic), or an object { all:[], any:[] } for more complex AND/OR conditions.
// Empty/undefined requirement allows by default; invalid types fail.
// Returns true only if all `all` subscriptions match AND at least one `any` subscription matches.
const evaluateSubscriptionRequirement = (siteSubscriptions, require) => {
    siteSubscriptions = Array.isArray(siteSubscriptions) ? siteSubscriptions : [];

    // No requirement → allow
    if (!require) return true;

    let all = [];
    let any = [];

    if (Array.isArray(require)) {
        // Legacy shorthand: OR logic
        any = require;
    }
    else if (typeof require === 'string') {
        // Legacy shorthand: single subscription OR
        any = [require];
    }
    else if (typeof require === 'object') {
        const hasAll = Array.isArray(require.all);
        const hasAny = Array.isArray(require.any);

        if (!hasAll && !hasAny) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn("RequireSubscription: object missing 'all' or 'any' keys:", require);
            }
            return false;
        }

        all = hasAll ? require.all : [];
        any = hasAny ? require.any : [];
    }
    else {
        if (process.env.NODE_ENV !== 'production') {
            console.warn("RequireSubscription: invalid requirement type:", require);
        }
        return false;
    }

    // Clean out falsy values
    all = all.filter(Boolean);
    any = any.filter(Boolean);

    const has = s => siteSubscriptions.includes(s);

    const allOk = all.length === 0 || all.every(has);
    const anyOk = any.length === 0 || any.some(has);

    return allOk && anyOk;
}
